<!-- @format -->

<template>
    <div
        class="gst-btn-classification__group u-overflow-auto-x u-white-space-nowrap u-hide-scrollbar">
        <v-btn-toggle
            :value="value || allCategory.id"
            group
            @change="onChange">
            <CategoryFilterButton
                v-if="allCategory.id"
                :key="allCategory.id"
                :value="allCategory.id"
                :text="$t(`${getKey(allCategory.id)}`)" />
            <CategoryFilterButton
                v-for="item in items"
                :key="item.id"
                :value="item.id"
                :text="$t(`${getKey(item.id)}`)" />
        </v-btn-toggle>
    </div>
</template>
<script>
import CategoryFilterButton from '@tenant/app/components/buttons/CategoryFilterButton.vue';
import categoriesConstants from '@tenant/app/utils/constants/categories.js';

export default {
    name: 'LatestDealsCategoryFilter',
    components: {
        CategoryFilterButton,
    },
    testIdOptions: {
        keyPrefix: 'home.topEvents.filter.category',
    },
    props: {
        value: {
            type: String,
            default: null,
        },
        items: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        allCategory() {
            return { id: categoriesConstants.LIST_ID.ALL };
        },
    },
    methods: {
        onChange(value) {
            this.$emit('input', value);
        },
        getKey(id) {
            let found = categoriesConstants.LIST.find((item) => item.ID === id);
            return found.i18nKey;
        },
    },
};
</script>
